import React from 'react';
import { ASK_CHOICE_TOOL } from '@/experiences/sales-portal/domain/superintelligence/constants';
import {
  type AssistantToolProps,
  useAssistantTool,
} from '@assistant-ui/core/react';

export interface AskChoiceArgs {
  options: string[];
  question: string;
}

export interface AskChoiceResult {
  choice: string;
}

/**
 * A frontend tool call ends the run; the app resolves it and the result goes out with the next run
 * (agent-platform docs/agui-contract.md).
 */
// assistant-ui's tool generic needs an index signature; the JSON schema is the real contract.
const ASK_CHOICE: AssistantToolProps<
  Record<string, unknown>,
  AskChoiceResult
> = {
  description:
    'Ask the user to pick exactly one of a few concrete options (which location, which of these orders, which ' +
    'item). Use it instead of listing the options in prose whenever the answer is one of a short fixed list; the ' +
    'app shows the options as buttons and returns the pick. Do not use it for open questions.',
  parameters: {
    additionalProperties: false,
    properties: {
      options: {
        description:
          'The choices, worded as the user would say them; each becomes a button.',
        items: { type: 'string' },
        maxItems: 6,
        minItems: 2,
        type: 'array',
      },
      question: {
        description: 'The one thing the user must decide, as a short question.',
        type: 'string',
      },
    },
    required: ['question', 'options'],
    type: 'object',
  },
  toolName: ASK_CHOICE_TOOL,
  type: 'frontend',
};

/** Render once inside the runtime provider. */
export const AgentFrontendTools: React.FC = () => {
  useAssistantTool(ASK_CHOICE);
  return null;
};
